export default __webpack_public_path__ + "static/media/beautiful-shot-modern-house-kitchen (1)@2x.40cb571c.png";